/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Outreach_Noprospects_Description2Inputs */

const en_coinvestments_outreach_noprospects_description2 = /** @type {(inputs: Coinvestments_Outreach_Noprospects_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add prospects and approve on the <link>Prospects</link> page to start sending deals.`)
};

/**
* | output |
* | --- |
* | "Add prospects and approve on the <link>Prospects</link> page to start sending deals." |
*
* @param {Coinvestments_Outreach_Noprospects_Description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_outreach_noprospects_description2 = /** @type {((inputs?: Coinvestments_Outreach_Noprospects_Description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Outreach_Noprospects_Description2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_outreach_noprospects_description2(inputs)
});
export { coinvestments_outreach_noprospects_description2 as "coInvestments_outreach_noProspects_description" }